import React from 'react';
import { Button, Flex, FlexProps, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { BulletinTag } from '../../Utils/BulletinTag';

interface Props extends Pick<FlexProps, 'mt'> {
  selectedTags: BulletinTag[];
  onTagToggle: (tag: BulletinTag) => void;
}

const FILTER_TAGS: BulletinTag[] = ['系統維護', '最新消息', '新功能上線'];

const TAG_STYLES: Record<BulletinTag, { bg: string; width: string; borderRadius: string }> = {
  系統維護:   { bg: '#99DDFF', width: '93px',  borderRadius: '5px' },
  最新消息:   { bg: '#D3B910', width: '93px',  borderRadius: '5px' },
  新功能上線: { bg: '#00AAFF', width: '111px', borderRadius: '5px' },
};

export const BulletinTagFilter: React.FC<Props> = ({ selectedTags, onTagToggle, mt }) => {
  const { t } = useTranslation();
  return (
    <Flex w="1040px" align="center" gap="21px" h="31px" mt={mt}>
      <Text fontFamily="'Open Sans', sans-serif" fontSize="16px" fontWeight={400}
        lineHeight="150%" letterSpacing="0.01em" color="#000000">
        {t('bulletin.filterLabel')}
      </Text>
      <Flex align="center" gap="13px">
        {FILTER_TAGS.map((tag) => {
          const style = TAG_STYLES[tag];
          const isActive = selectedTags.includes(tag);
          return (
            <Button
              key={tag}
              onClick={() => onTagToggle(tag)}
              h="31px" minW={style.width} px="10px" py="2px"
              borderRadius={style.borderRadius}
              bg={isActive ? style.bg : '#E0E0E0'}
              color="#FFFFFF" border="none"
              fontFamily="'Open Sans', sans-serif" fontSize="18px" fontWeight={400}
              lineHeight="150%" letterSpacing="0.01em"
              _hover={{ bg: isActive ? style.bg : '#E0E0E0' }}
              _active={{ bg: isActive ? style.bg : '#E0E0E0' }}
            >
              {t(`bulletin.tags.${tag}`)}
            </Button>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default BulletinTagFilter;
